/**
 * Miscellaneous frontend helpers.
 *
 * Currently exposes `delay` – returns a promise that resolves after `ms` milliseconds. Useful for mocking
 * async latency in local-only fallbacks.
 */
export function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
